/* Raven Performance – Hamburger-Header, Sidebar, Suche */
(function () {
  function init() {
    var html = document.documentElement;
    var body = document.body;
    var openBtn = document.querySelector('[data-rv-open]');
    var sidebar = document.querySelector('[data-rv-sidebar]');
    var overlay = document.querySelector('[data-rv-overlay]');
    var closeEls = document.querySelectorAll('[data-rv-close]');
    if (!openBtn || !sidebar || !overlay) return;
    if (openBtn.dataset.rvReady === '1') return;
    openBtn.dataset.rvReady = '1';

    var scrollY = 0;
    function lock() {
      scrollY = window.scrollY;
      body.classList.add('rv-locked');
    }
    function unlock() { body.classList.remove('rv-locked'); }

    function open() {
      sidebar.classList.add('is-open');
      overlay.classList.add('is-open');
      html.classList.add('rv-menu-open');
      openBtn.setAttribute('aria-expanded', 'true');
      sidebar.setAttribute('aria-hidden', 'false');
      lock();
      var first = sidebar.querySelector('button, a');
      if (first) { try { first.focus({ preventScroll: true }); } catch (e) {} }
    }
    function close() {
      sidebar.classList.remove('is-open');
      overlay.classList.remove('is-open');
      html.classList.remove('rv-menu-open');
      openBtn.setAttribute('aria-expanded', 'false');
      sidebar.setAttribute('aria-hidden', 'true');
      unlock();
    }
    function toggle() { sidebar.classList.contains('is-open') ? close() : open(); }

    openBtn.addEventListener('click', toggle);
    overlay.addEventListener('click', close);
    closeEls.forEach(function (el) { el.addEventListener('click', close); });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(); closeSearch(); }
    });

    // Search overlay
    var searchWrap = document.querySelector('[data-rv-search]');
    var searchOpen = document.querySelector('[data-rv-search-open]');
    var searchClose = document.querySelector('[data-rv-search-close]');
    function openSearch() {
      if (!searchWrap) return;
      searchWrap.classList.add('is-open');
      var inp = searchWrap.querySelector('input');
      if (inp) { setTimeout(function () { try { inp.focus(); } catch (e) {} }, 120); }
    }
    function closeSearch() { if (searchWrap) searchWrap.classList.remove('is-open'); }
    if (searchOpen) searchOpen.addEventListener('click', openSearch);
    if (searchClose) searchClose.addEventListener('click', closeSearch);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else { init(); }
  document.addEventListener('shopify:section:load', init);
})();
